class LqdModalHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);
    
    this.handleDestroy();

    this.initModal();

  }

  getDefaultSettings() {
    return {
      selectors: {
        modalElement: 'lqd-modal',
        triggerElement: `[data-lqd-lity=#modal-${this.getElementSettings().modal}]`
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $modalElement: this.$element.find(selectors.modalElement),
      $triggerElement: elementorFrontend.elements.$body.find(selectors.triggerElement),
    }
  }

  initModal() {

    this.elements.$triggerElement.liquidLightBox();

  }

  onDestroy() {
      
    this.handleDestroy();

    super.onDestroy();
  
  }

  handleDestroy() {

    this.handleModalDestroy();

  }

  handleModalDestroy() {
    
    if ( ! this.elements.$triggerElement.length ) return;
    
    const modalData = this.elements.$triggerElement.data('plugin_liquidLightBox');

    if ( modalData ) {
      modalData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdModalHandler, { $element } );
};